module.exports = __webpack_public_path__ + "static/img/city-of-philadelphia-logo.09d4440b.png";